"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.SelectMenu = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
function SelectMenu(props) {
    var style = props.style, menuRef = props.menuRef, rest = __rest(props, ["style", "menuRef"]);
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    return react_1.default.createElement("ul", __assign({ role: 'listbox', className: css(classes.list, style), ref: menuRef }, rest));
}
exports.SelectMenu = SelectMenu;
exports.createStyles = function (theme) { return ({
    list: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        border: "1px solid " + theme.pallete.divider,
        borderRadius: theme.radius.popper,
        backgroundColor: theme.pallete.surface.main,
        boxShadow: theme.shadows.outer['40'],
        maxHeight: '20rem',
        overflowY: 'auto',
        overflowX: 'hidden',
        width: '100%',
        zIndex: theme.zIndex.dropdown,
    },
}); };
//# sourceMappingURL=SelectMenu.js.map